package com.milta.core.localization.translations.sq

import com.milta.core.localization.SubscriptionExpiredStrings

internal val SubscriptionExpired = SubscriptionExpiredStrings(
    title = "Abonimi ka skaduar",
    driverSoloMessage = "Abonimi juaj ka skaduar. Rinovoni për të vazhduar.",
    patronMessage = "Abonimi juaj ka skaduar. Ekipi juaj nuk mund të aksesojë më Milta.",
    driverUnderPatronMessage = "Abonimi i organizatës tuaj ka skaduar. Kontaktoni organizatën tuaj për të rikthyer aksesin.",
    renewButton = "Rinovo",
    close = "Mbyll",
    subscribeButtonTemplate = "Abonohuni për %s",
    driverLinkCodeHint = "Punoni për një ndërmarrje? Jepini këtë kod: pasi të lidheni, mbuloheni nga abonimi i saj.",
    checkAccessButton = "Kontrollo aksesin tim",
    accessStillUnavailable = "Aksesi ende i padisponueshëm",
)
